export type { SystemMessageProps, SystemMessageSlots, SystemMessageState } from './components/SystemMessage/index';
export { SystemMessage, renderSystemMessage_unstable, systemMessageClassNames, useSystemMessageStyles_unstable, useSystemMessage_unstable } from './components/SystemMessage/index';
